<app-masterpage>
</app-masterpage>
<div class="page-wrapper">
    <app-header>
    </app-header>
    <div class="container-fluid pt-custom pb-5">
        <div class="row ">
            <div class="col-lg-12">
                <div class="header">
                    <h4 class="title">College Register Detail</h4>
                </div>
                <div class="row justify-content-center card">
                    <div class="col-lg-12 col-md-12 col-12 p-4">
                        <div class="row">
                            <div class="form-group col-lg-4 col-md-12 col-12">
                                <label>Status
                                </label>
                                <select class="form-control" #Status name="Status" id="Status">
                                    <option value="0" selected>All</option>
                                    <option value="1">Approved</option>
                                    <option value="2">Reject</option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-lg-1 col-md-1 col-5">
                                <button type="button" (click)="onSubmit()" class="col-lg-12 btn btn-primary mr-3">Show</button>
                            </div>
                            <div class="form-group col-lg-4 col-md-2 col-7">
                                <button type="button" id="btnExcel" (click)="ExportToExcel()" style="display: none;"
                                    class="btn btn-primary  mr-3">Export to
                                    excel</button>
                            </div>

                        </div>
                        <div class="row" id="divclgList" style="display: none;"
                          >
                            <div class=" col-lg-12 col-md-12 col-12 p-4">
                                <div class="table-responsive">
                                    <table id="example" class="table table-striped table-bordered" style="width:100%">
                                        <thead>
                                            <tr>
                                                <!-- <th class="pointer"(click)="sortBy('Board')">Name</th> -->
                                                <th class="pointer" scope="col">Sr. No.</th>
                                                <th class="pointer" scope="col">Registration Date</th>
                                                <th class="pointer" scope="col">College Name</th>
                                                <th class="pointer" scope="col">Type Of Trust</th>
                                                <th class="pointer" scope="col">College Mail ID</th>
                                                <th class="pointer" scope="col">Status</th>
                                            </tr>
                                        </thead>
                                        <tbody style="font-size: small;">
                                            <tr
                                                *ngFor="let r of registrationlist | paginate: { itemsPerPage: pageLimit, currentPage: p };let i = index">
                                                <td>{{r.SrNo}}</td>
                                                <td>
                                                    <p>{{r.RegistrationDate}}</p>
                                                </td>
                                                <td>
                                                    <p>{{r.SchoolName}}</p>
                                                </td>
                                                <td>
                                                    <p>{{r.TrustType}}</p>
                                                </td>
                                                <td>
                                                    <p>{{r.SchoolMailID}}</p>
                                                </td>
                                                <td>
                                                    <div *ngIf="r.Status == 'Pending';">
                                                        <span class="badge badge-primary"
                                                            style="font-size: larger;">Pending</span>
                                                    </div>
                                                    <div *ngIf="r.Status == 'Approve';">
                                                        <span class="badge badge-success"
                                                            style="font-size: larger;">Approved</span>
                                                    </div>
                                                    <div *ngIf="r.Status == 'Reject';">
                                                        <span class="badge badge-danger"
                                                            style="font-size: larger;">Rejected</span>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="card-footer pb-3 pt-3 mb-4" align="center">
                                    <pagination-controls (pageChange)="p = $event"></pagination-controls>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <table class="table table-bordered" #TABLE style="display: none;">
        <thead>
            <tr>
                <th scope="col">Sr No.</th>
                <th scope="col">UDise No.</th>
                <th scope="col">SSC Index No.</th>
                <th scope="col">HSC Index No.</th>
                <th scope="col">Office</th>
                <th scope="col">Trust Type</th>
                <th scope="col">Affiliation Number Acquire Date</th>
                <th scope="col">Affiliation Number</th>
                <th scope="col">Acquire Date</th>
                <th scope="col">Area</th>
                <th scope="col">State</th>
                <th scope="col">City</th>
                <th scope="col">Trust</th>
                <th scope="col">Trust Address</th>
                <th scope="col">Trust Mobile No.</th>
                <th scope="col">Trust Mail ID</th>
                <th scope="col">College Name</th>
                <th scope="col">College Address</th>
                <th scope="col">College Mobile No.</th>
                <th scope="col">College Email</th>
                <th scope="col">College Location</th>
                <th scope="col">College Type</th>
                <th scope="col">Registration Date</th>
                <th scope="col">Status</th>
                <th scope="col">Remark</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let user of registrationlist">
                <td>
                    <p>{{user.SrNo}}</p>
                </td>
                <td>
                    <p>{{user.UDiseNo}}</p>
                </td>
                <td>
                    <p>{{user.SSCIndexNo}}</p>
                </td>
                <td>
                    <p>{{user.HSCIndexNO}}</p>
                </td>
                <td>
                    <p>{{user.Office}}</p>
                </td>
                <td>
                    <p>{{user.TrustType}}</p>
                </td>
                <td>
                    <p>{{user.AffiliationNumberAcquireDate}}</p>
                </td>
                <td>
                    <p>{{user.AffiliationNumber}}</p>
                </td>
                <td>
                    <p>{{user.AcquireDate}}</p>
                </td>
                <td>
                    <p>{{user.Area}}</p>
                </td>
                <td>
                    <p>{{user.State}}</p>
                </td>
                <td>
                    <p>{{user.City}}</p>
                </td>
                <td>
                    <p>{{user.Trust}}</p>
                </td>
                <td>
                    <p>{{user.TrustAddress}}</p>
                </td>
                <td>
                    <p>{{user.TrustMobileNo}}</p>
                </td>
                <td>
                    <p>{{user.TrustMailID}}</p>
                </td>
                <td>
                    <p>{{user.SchoolName}}</p>
                </td>
                <td>
                    <p>{{user.SchoolAddress}}</p>
                </td>
                <td>
                    <p>{{user.SchoolMobileno}}</p>
                </td>
                <td>
                    <p>{{user.SchoolMailID}}</p>
                </td>
                <td>
                    <p>{{user.SchoolLocation}}</p>
                </td>
                <td>
                    <p>{{user.SchoolType}}</p>
                </td>
                <td>
                    <p>{{user.RegistrationDate}}</p>
                </td>
                <td>
                    <p>{{user.Status}}</p>
                </td>
                <td>
                    <p>{{user.Remarks}}</p>
                </td>

            </tr>
        </tbody>
    </table>

    <div class="footer-login custom-footer">
        <p class="mb-0">Copyright © Netsol IT Solution Pvt. Ltd. 2020 All Rights Reserved</p>
        <img src="assets/images/powered-by.png" alt="netsol-powerd by" class="img-fluid">
    </div>
    <ngx-spinner bdcolor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
        <p style="color: white;">Please Wait.</p>
    </ngx-spinner>
</div>